import React, {useEffect} from 'react';
import {
   View,
   Text,
   StyleSheet,
   TouchableOpacity,
   Platform,
   Image,
   ScrollView,
} from 'react-native';

import {
   appBackgroundWhiteBG,
   base100,
   buttonBorderColor,
   CONTACT_US,
   DoNotHaveAnAccount,
   NORCAT_ORG,
   primaryColor400,
   primaryColor500,
   primaryState50,
   primaryState500,
   primaryState800,
   redirectToBrowser,
   white,
   FONT_FAMILY_SEMI_BOLD,
   FONT_FAMILY_MEDIUM,
   FONT_FAMILY_REGULAR,
   logoutMessage,
   accountSignOut,
   contactUs,
   norcatOrg,
   cancel,
   confirm,
   BUTTON_HOVER_COLOR,
   BACK_BUTTON_HOVER_COLOR,
   WHITE_BUTTON_HOVER_COLOR,
} from '../../utils/utils';

import {useDispatch} from 'react-redux';
import {useNavigation} from '@react-navigation/native';
import {setSignIn} from '../../redux/slices/AuthSlice';
import logger from '../../utils/logger';
import {logoutHandler} from '../../service/network_access';
import {ContactUsLink, NorcatOrgBtn} from '../../components/common';

const LogoutCard = props => {
   const navigation = useNavigation();
   const dispatch = useDispatch();
   const [confirmHover, setConfirmlHover] = React.useState(false);
   const [cancelHover, setCancelHover] = React.useState(false);
   useEffect(() => {
      logger(Platform);
   }, []);
   return (
      <View style={styles.cardContainer}>
         <ScrollView style={{marginBottom: 50}}>
            <View style={{justifyContent: 'flex-start', alignItems: 'center'}}>
               <View style={styles.card}>
                  <View
                     style={{
                        flex: 1,
                        justifyContent: 'space-between',
                        alignItems: 'center',
                     }}>
                     <View
                        style={{
                           flex: 1,
                           justifyContent: 'flex-start',
                           alignItems: 'center',
                        }}>
                        <View style={styles.CircleShape}>
                           <Image
                              source={require('../../assets/logout_black.png')}
                              style={{
                                 width: 100,
                                 height: 100,
                                 resizeMode: 'contain',
                              }}
                           />
                        </View>
                        <Text
                           style={{
                              fontSize: 20,
                              color: primaryState800,
                              fontWeight: '600',
                              fontFamily: FONT_FAMILY_SEMI_BOLD,
                           }}>
                           {accountSignOut}
                        </Text>
                        <Text
                           style={{
                              fontSize: 12,
                              fontWeight: '500',
                              color: primaryState500,
                              marginTop: 8,
                              textAlign: 'center',
                              fontFamily: FONT_FAMILY_MEDIUM,
                           }}>
                           {logoutMessage}
                        </Text>
                     </View>
                     <View
                        style={{
                           flexDirection: 'row',
                           marginTop: 16,
                           width: '100%',
                        }}>
                        <View style={{flex: 1, marginRight: 16}}>
                           <TouchableOpacity
                              style={{
                                 backgroundColor: cancelHover
                                    ? WHITE_BUTTON_HOVER_COLOR
                                    : white,
                                 minHeight: 48,
                                 borderRadius: 6,
                                 justifyContent: 'center',
                                 borderWidth: 1,
                                 borderColor: primaryColor400,
                                 ...Platform.select({
                                    windows: {
                                       borderWidth: 1.01,
                                    },
                                 }),
                              }}
                              onMouseEnter={() => {
                                 setCancelHover(true);
                              }}
                              onMouseLeave={() => {
                                 setCancelHover(false);
                              }}
                              onPress={() => {
                                 navigation.goBack();
                              }}>
                              <Text
                                 style={{
                                    color: primaryColor500,
                                    fontSize: 16,
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    fontFamily: FONT_FAMILY_MEDIUM,
                                 }}>
                                 {cancel}
                              </Text>
                           </TouchableOpacity>
                        </View>
                        <View style={{flex: 1}}>
                           <TouchableOpacity
                              style={{
                                 backgroundColor: confirmHover
                                    ? BUTTON_HOVER_COLOR
                                    : primaryColor500,
                                 minHeight: 48,
                                 borderRadius: 6,
                                 justifyContent: 'center',
                              }}
                              onMouseEnter={() => {
                                 setConfirmlHover(true);
                              }}
                              onMouseLeave={() => {
                                 setConfirmlHover(false);
                              }}
                              onPress={() => {
                                 const user = {
                                    isLoggedIn: false,
                                    userName: '',
                                 };
                                 Platform.OS === 'web'
                                    ? logoutHandler()
                                    : dispatch(setSignIn(user));
                              }}>
                              <Text
                                 style={{
                                    color: 'white',
                                    fontSize: 16,
                                    fontWeight: '500',
                                    textAlign: 'center',
                                    fontFamily: FONT_FAMILY_MEDIUM,
                                 }}>
                                 {confirm}
                              </Text>
                           </TouchableOpacity>
                        </View>
                     </View>
                  </View>
               </View>
            </View>
            <View
               style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: 24,
               }}>
               <Text
                  style={{
                     textAlign: 'center',
                     fontWeight: '400',
                     fontSize: 14,
                     color: base100,
                     fontFamily: FONT_FAMILY_REGULAR,
                  }}>
                  {DoNotHaveAnAccount}
               </Text>
               <ContactUsLink />
               {/* <TouchableOpacity
                  onPress={() => {
                     redirectToBrowser({url: CONTACT_US});
                  }}>
                  <Text
                     style={{
                        fontSize: 14,
                        fontWeight: '700',
                        textAlign: 'center',
                        color: primaryColor500,
                        marginLeft: 8,
                        fontFamily: FONT_FAMILY_MEDIUM,
                     }}>
                     {contactUs}
                  </Text>
               </TouchableOpacity> */}
            </View>
            <View style={{alignItems: 'center'}}>
               <NorcatOrgBtn />
               {/* <TouchableOpacity
                  style={{
                     backgroundColor: white,
                     paddingTop: 8,
                     paddingBottom: 8,
                     paddingLeft: 20,
                     paddingRight: 20,
                     borderRadius: 5,
                     borderWidth: 1,
                     borderColor: primaryColor400,
                     marginTop: 16,
                     ...Platform.select({
                        windows: {
                           paddingBottom: 9,
                        },
                     }),
                  }}
                  onPress={() => {
                     redirectToBrowser({url: NORCAT_ORG});
                     // navigation.navigate('QRAndBarcodeScreen');
                  }}>
                  <Text
                     style={{
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        color: primaryColor500,
                        fontSize: 14,
                        fontWeight: '700',
                        fontFamily: FONT_FAMILY_MEDIUM,
                     }}>
                     {norcatOrg}
                  </Text>
               </TouchableOpacity> */}
            </View>
         </ScrollView>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {backgroundColor: appBackgroundWhiteBG, flex: 1},
   cardContainer: {
      marginTop: 24,
      marginEnd: 24,
      marginStart: 24,
      flexDirection: 'column',
   },
   card: {
      backgroundColor: '#fff',
      shadowOffset: {width: 0, height: 1},
      shadowColor: '#333',
      shadowOpacity: 0.3,
      shadowRadius: Platform.OS === 'web' ? 7 : 2,
      width: '99%',
      padding: 16,
      minHeight: 224,
      elevation: 5,
      marginTop: 5,
      borderColor:
         Platform.OS === 'windows' ? 'rgba(158, 150, 150, 0.2)' : null,
      borderWidth: Platform.OS === 'windows' ? 2 : null,
      borderRadius: Platform.OS === 'windows' ? 10 : null,
   },
   cardContent: {
      marginVertical: 5,
      alignContent: 'center',
      justifyContent: 'flex-start',
      padding: 24,
   },
   sectionTitle: {
      fontSize: 20,
      fontWeight: '600',
      textAlign: 'center',
      color: primaryState800,
      marginBottom: 16,
      fontFamily: FONT_FAMILY_SEMI_BOLD,
   },
   line: {
      borderBottomWidth: 0.5,
      buttonBorderColor: base100,
      marginBottom: 24,
   },
   inputStyle: {
      width: Platform.OS === 'web' ? '30%' : '100%',
      backgroundColor: white,
      marginBottom: 16,
      alignItems: 'flex-end',
      borderRadius: 4,
      fontSize: 12,
      padding: 5,
   },
   signUpButton: {
      backgroundColor: primaryColor500,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
   },
   qrButton: {
      backgroundColor: white,
      minHeight: 48,
      borderRadius: 6,
      justifyContent: 'center',
      marginTop: 10,
      borderWidth: 1,
      borderColor: buttonBorderColor,
   },
   buttonText: {
      color: 'white',
      fontSize: 16,
      fontWeight: '500',
      textAlign: 'center',
      fontFamily: FONT_FAMILY_MEDIUM,
   },
   CircleShape: {
      width: 100,
      height: 100,
      borderRadius: 100 / 2,
      backgroundColor: primaryState50,
      margin: 24,
   },
});

export default LogoutCard;
